const hy = {
  howUseful: 'Որքա՞ն օգտակար էր այս տեղեկությունը:',
  notUseful: 'Անօգտակար',
  veryUseful: 'Շատ օգտակար',
  thanks: 'Շնորհակալություն ձեր ներդրման համար',
};

export default hy;
